module.exports = __webpack_public_path__ + "static/img/9.5d9fce3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/8/zh/9.png
// module id = F4KT
// module chunks = 0